<template>
  <v-container fluid class="grey lighten-2">
    <v-row>
      <v-col class="mt-2" cols="12">
        <v-dialog v-model="dialog" max-width="800" scrollable persistent transition="dialog-bottom-transition">
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on">
              <v-icon id="eat_out">{{ icon }}</v-icon>{{ phrase.title_eat_out }}
            </v-btn>
          </template>

          <v-card height=400>
            <v-card-title class="text-h5 grey lighten-2">{{ phrase.title_eat_out }}</v-card-title>
            <v-card-text style="white-space: pre-line">
              <div class="my-5 text--primary">{{ help_eat_out_text }}</div>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="justify-start">
              <v-btn color="primary" text @click="dialog = false">
                {{ phrase.dialog_close }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <span class="ml-4 font-weight-bold header-total-inline">合計 {{ (this.$store.state.breakdown.eat_out.reduce((sum, i) => { return sum + i.order; }, 0)).toLocaleString() }}円</span>
      </v-col>
      <v-col>
        <v-row>
          <v-col class="mt-2 d-flex" cols="12" sm="6" md="3" lg="3" v-for="(eat_out, index) in this.$store.state.login_response.eat_out" :key="index">
            <v-card class="d-flex flex-column flex-grow-1">
              <v-card-title>{{ eat_out.course }}</v-card-title>
              <v-col align="center">
                <v-img max-height="200" max-width="200" v-bind:src="require('@/assets/eat_out/'+eat_out.img+'.jpg')"></v-img>
              </v-col>
              <v-card-text>
                <v-simple-table>
                  <thead></thead>
                  <tbody>
                    <tr>
                      <td>メニュー</td>
                      <td>{{ eat_out.menu }}</td>
                    </tr>
                    <tr>
                      <td>1人の金額</td>
                      <td>{{ eat_out.cost.toLocaleString() }}円</td>
                    </tr>
                  </tbody>
                </v-simple-table>
                <br>
                <v-select :items=array return-object :label="$store.state.select.eat_out[index]" dense @change="value_eat_out(index, $event)"></v-select>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import words from '../assets/words.json'

export default({
  data: () => ({
    icon: 'mdi-silverware',
    cost_total: 0,
    people: 1,
    array: [],
    dialog: false,
    phrase: {}
  }),
  mounted: function () {
    this.getWords()
  },
  computed: {
    help_eat_out_text () {
      return this.phrase.help_eat_out
    }
  },
  methods: {
    generateArray() {
      this.array = [...Array(this.people+1).keys()];
    },
    value_eat_out: function(index, num) {
      this.$store.commit('value_eat_out', {index, num});
      this.$store.commit('rebalance');
      this.$store.commit('set_progress');
    },
    getWords: function () {
      this.phrase = words
    }
  },
  created() {
    if(this.$store.state.login_response.persona.is_married == 1){
      this.people++;
    }
    if('child1_age' in this.$store.state.login_response.persona){
      this.people++;
    }
    if('child2_age' in this.$store.state.login_response.persona){
      this.people++;
    }
    this.generateArray();
    this.$store.commit('initialize_eat_out', this.$store.state.login_response.eat_out);
  }
})
</script>
